import { createTheme } from '@mui/material/styles';

const gms = createTheme({
  palette: {
    primary: {
      light: '#00C072',
      main: '#00A361',
      dark: '#00483B',
      contrastText: '#ffffff',
    },
    secondary: {
      light: '#E6F8F1',
      main: '#C2F0DD',
      dark: '#99E6C7',
      contrastText: '#fff',
    },
    type: 'light',
    custom: {
      appBarColor: '#00C072',
    },
    online: {
      main: '#4caf50',
    },
    away: {
      main: '#ffd700',
    },
    offline: {
      main: '#d32f2f',
    },
    unknown: {
      main: '#a9a9a9',
    },
    infobox: {
      color: {
        orange: '#838FF7',
        red: '#C3E4FD',
        blue: '#48A1F8',
        green: '#00C072',
        grey: '#D1D2FB',
        viber: '#7360F2',
        whatsapp: '#25d366',
        sms: '#97bbcd',
      },
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollbarColor: '#0000004d',
          '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
            backgroundColor: '#fff',
          },
          '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
            borderRadius: 16,
            border: '2px solid #fff',
            backgroundColor: '#0000004d',
          },
        },
      },
    },
  },
});

export default gms;
